


















































































































import { Component, Prop, PropSync, Vue, Ref } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

@Component({
  computed: {
    ...mapState('User', {
      businessGroups: 'businessGroups',
    }),
    ...mapState('Auth', {
      business: 'activeBusiness',
    }),
  },
})
export default class BusinessUpdateUserForm extends Vue {
  @Prop({ default: () => ({}) }) user!: Model;
  @Prop() readonly businessOid!: string;
  @PropSync('showSheet') syncedShowSheet!: boolean;
  @Ref() readonly form!: { setErrors: (any?: any) => void };

  business!: Model;

  isMounted = false;
  isLoading = false;
  businessGroups!: { code: string }[];

  userLocal: {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    email: string | undefined;
    group_code: string | undefined;
  } = {
    id: undefined,
    name: '',
    surname: '',
    email: '',
    group_code: '',
  };

  validated = false;
  isNew = false;

  mounted() {
    if (!_.isEmpty(this.user)) {
      this.userLocal.id = this.user.id;
      this.userLocal.name = this.user.name;
      this.userLocal.surname = this.user.surname;
      this.userLocal.email = this.user.email;
      this.userLocal.group_code = this.user.ubg[0].group.code;
      this.isNew = false;
    } else {
      this.initValues();
    }

    if (this.businessGroups.length == 0) {
      this.$store.dispatch('User/groups').then(() => {
        this.isMounted = true;
      });
    } else {
      this.isMounted = true;
    }
  }

  handleSubmitUser() {
    this.isLoading = true;
    const action = this.userLocal.id
      ? 'Business/updateUser'
      : 'Business/addUser';
    this.$store
      .dispatch(action, {
        user: this.userLocal,
        businessOid: this.businessOid,
      })
      .then(() => {
        this.isLoading = false;
        this.syncedShowSheet = false;
        this.$emit('update');
      })
      .catch(() => {
        this.isLoading = false;
      });
  }

  initValues() {
    this.userLocal.id = undefined;
    this.userLocal.name = '';
    this.userLocal.surname = '';
    this.userLocal.email = '';
    this.userLocal.group_code = '';
    this.isNew = false;
  }

  validateEmail() {
    this.isLoading = true;

    this.validated = false;
    this.isNew = false;

    this.$store
      .dispatch('Business/validateEmail', {
        businessOid: this.business.object_id,
        email: this.userLocal.email,
        id: this.userLocal.id,
      })
      .then((response) => {
        this.isNew = !response.data.data;
      })
      .catch(({ response }) => {
        for (const key in response.data.error) {
          let ref;
          if (key.includes('email')) {
            ref = this.$refs[key];
            if (ref) {
              ref.setErrors(response.data.error[key]);
            }
          }
          // this.$refs[key].setErrors(response.data.error[key])
        }
        return response;
      })
      .finally(() => {
        this.isLoading = false;
        this.validated = true;
      });
  }

  get selectedBusinessGroup() {
    return this.businessGroups.find(
      (group) => group.code == this.userLocal.group_code
    );
  }
}
